import React, { useState } from 'react';
import { Form, Input, Button, notification } from 'antd';
import { updatePassword } from '../../../Apis/God';

const AddForm = ({ selectedUser, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async values => {
    if (values.newPassword.length < 8) {
      return notification.error({
        message: 'Invalid Password',
        description: 'Password must be at least 8 characters'
      });
    }

    if (values.newPassword !== values.confirmPassword) {
      return notification.error({
        message: 'Mismatch',
        description: 'Passwords do not match'
      });
    }

    setLoading(true);

    try {
      const response = await updatePassword(
        selectedUser.id,
        values.newPassword
      );

      notification.success({
        message: 'Success',
        description: 'Password updated successfully'
      });

      onSuccess();
    } catch (err) {
      notification.error({
        message: 'Failed',
        description: err?.response?.data?.message || 'Failed to update password'
      });
    }

    setLoading(false);
  };

  return (
    <Form layout='vertical' onFinish={onFinish}>
      <Form.Item
        label='New Password'
        name='newPassword'
        rules={[{ required: true }]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        label='Confirm Password'
        name='confirmPassword'
        rules={[{ required: true }]}
      >
        <Input.Password />
      </Form.Item>

      <Button type='primary' htmlType='submit' loading={loading} block>
        Update
      </Button>
    </Form>
  );
};

export default AddForm;
